"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5075,4376],{

/***/ 45938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var ab_cards__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84691);


var Wellness = function(param) {
    var classname = param.classname, moduloCross = param.moduloCross, i18n = param.i18n;
    var disfrute = moduloCross === null || moduloCross === void 0 ? void 0 : moduloCross.modCrossWellness;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_cards__WEBPACK_IMPORTED_MODULE_1__["default"], {
        className: classname,
        title: i18n.language == "en" ? (disfrute === null || disfrute === void 0 ? void 0 : disfrute.titlewellnessen) || (disfrute === null || disfrute === void 0 ? void 0 : disfrute.titlewellness) : i18n.language == "de" ? (disfrute === null || disfrute === void 0 ? void 0 : disfrute.titlewellnessde) || (disfrute === null || disfrute === void 0 ? void 0 : disfrute.titlewellness) : disfrute === null || disfrute === void 0 ? void 0 : disfrute.titlewellness,
        cards: disfrute === null || disfrute === void 0 ? void 0 : disfrute.cardswellness,
        text: disfrute === null || disfrute === void 0 ? void 0 : disfrute.textwellness,
        animated: disfrute === null || disfrute === void 0 ? void 0 : disfrute.animatedwellness,
        i18n: i18n
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Wellness);


/***/ })

}]);